import { render, staticRenderFns } from "./ChildStonks.vue?vue&type=template&id=45bd1dd8&scoped=true"
import script from "./ChildStonks.vue?vue&type=script&lang=js"
export * from "./ChildStonks.vue?vue&type=script&lang=js"
import style0 from "./ChildStonks.vue?vue&type=style&index=0&id=45bd1dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd1dd8",
  null
  
)

export default component.exports